var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portal",class:_vm.getTheme,attrs:{"id":"app"}},[_c('AppMain'),_c('CookieMessage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }